import styles from './Screen.module.scss';

import cn from 'classnames';
import { LazyMotion, domAnimation } from 'framer-motion';
import * as m from 'framer-motion/m';

import React, { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  isWholeScreen?: boolean;
}

export const Screen = ({ children, className, isWholeScreen }: Props) => {
  return (
    <LazyMotion features={domAnimation}>
      <m.div
        className={cn(
          styles.screen,
          'app-screen',
          className,
          isWholeScreen && styles.wholeScreen,
        )}
        initial={{ x: '-100%' }}
        animate={{ x: 0 }}
        exit={{ x: '100%' }}
        transition={{ ease: 'easeInOut', duration: 0.15 }}
      >
        {children}
      </m.div>
    </LazyMotion>
  );
};
